<-- 核心产品列表页面 -->
<template>
    <div class="w100">
        <div  class="w100 pos_re">
            <img src="../../static/img/ringone_banner.png" class="w100 banner_img">
            <div class="banner">
            <div class="dis_column just_cen ali_cen banner_con">
                <p class="banner_title">企业彩铃</p>
                <p class="banner_des">企业有声名片</p>
                <p class="banner_con_text">企业彩铃为企业客户提升企业形象和知名度的产品,每一次来电都是对企业形象的自我宣传，有效提升企业知名度。</p>
            </div>
            </div>
        </div>
        <div class="w100">
            <div class="content" style="margin-top:5vw">
                <div class="w100 dis_column ali_cen">
                    <p class="con_title">企业应用场景</p>
                    <p class="con_title_des">ENTERPRISE APPLICATION SCENARIO</p>
                    <div class="dis_row ali_cen just_cen">
                        <p class="con_title_line"></p>
                        <img src="../../static/img/index/con_title_img.png" class="con_title_img">
                        <p class="con_title_line"></p>
                    </div>
                    <div class="dis_row just_bet w100 margin_top_2">
                        <div class="application_left dis_column ali_end">
                            <div class="application_left_icon dis_row just_bet ali_cen">
                                <div class="pos_re" style="width:6vw;height:5vw">
                                    <img src="../../static/img/application_left_icon.png" class="w100 h100">
                                    <p class="application_left_icon_num">1</p>
                                </div>
                                <div class="application_LL_icon dis_column just_cen">
                                    <p class="application_LL_icon_title">新品宣传</p>
                                    <p>客户服务部</p>
                                    <p style="width:18vw">定制新品宣传内容的铃音，用户致电咨询时可进一步宣传，提高知名度。</p>
                                </div>
                            </div>
                            <div class="application_left_icon dis_row just_bet ali_cen">
                                <div class="application_LL_icon dis_column just_cen">
                                    <p class="application_LL_icon_title">有声名片</p>
                                    <p>销售部</p>
                                    <p style="width:18vw">将企业名称、办公地址、联系方式录制成为彩铃，商机不流失。</p>
                                </div>
                                <div class="pos_re" style="width:6vw;height:5vw">
                                    <img src="../../static/img/application_left_icon.png" class="w100 h100">
                                    <p class="application_left_icon_num">2</p>
                                </div>
                            </div>
                            <div class="application_left_icon dis_row just_bet ali_cen">
                                <div class="pos_re" style="width:6vw;height:5vw">
                                    <img src="../../static/img/application_left_icon.png" class="w100 h100">
                                    <p class="application_left_icon_num">3</p>
                                </div>
                                <div class="application_LL_icon dis_column just_cen">
                                    <p class="application_LL_icon_title">企业歌曲</p>
                                    <p>管理层</p>
                                    <p style="width:18vw">彰显企业文化、提升品牌形象。</p>
                                </div>
                            </div>
                            <div class="application_left_icon dis_row just_bet ali_cen" >
                                <div class="application_LL_icon dis_column just_cen">
                                    <p class="application_LL_icon_title">节日祝福</p>
                                    <p>人力资源部</p>
                                    <p style="width:18vw">在恰当的节日里表达对企业的关怀、提高企业形象。</p>
                                </div>
                                <div class="pos_re" style="width:6vw;height:5vw">
                                    <img src="../../static/img/application_left_icon.png" class="w100 h100">
                                    <p class="application_left_icon_num">4</p>
                                </div>
                            </div>
                        </div>
                        <div class="application_right" >
                            <img src="../../static/img/1-1.png" class="w100 " style="height:24.5vw">
                            <div class="application_left_icon dis_row just_bet ali_cen" style="margin-top:1vw">
                                <div class="application_LL_icon dis_column just_cen">
                                    <p class="application_LL_icon_title">产品促销</p>
                                    <p>销售部</p>
                                    <p style="width:18vw">创作产品宣传、活动促销铃音，提高企业活动知名度。</p>
                                </div>
                                <div class="pos_re" style="width:6vw;height:5vw">
                                    <img src="../../static/img/application_left_icon.png" class="w100 h100">
                                    <p class="application_left_icon_num">5</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="w100 pos_re ringone_con_banner_div">
            <div class="content dis_column ali_cen" style="margin-top:0;padding-top:3vw">
                <div class="w100 dis_column ali_cen">
                    <p class="con_title" style="color:#fff">合作伙伴</p>
                    <p class="con_title_des" style="color:#fff">COOPERATIVE PARTNER</p>
                </div>
                <div class="dis_row just_bet ali_cen ringone_cc_banner_div">
                    <div class="ringone_con_banner_con dis_column ali_cen just_cen" v-for="(item,index) in partnerList" :key="index">
                        <p class="ringone_con_banner_con_t">{{item.title}}</p>
                        <img :src=item.img class="ringone_con_banner_con_i">
                        <p>{{item.con}}</p>
                    </div>
                </div>
            </div>
        </div> -->
        <div class="w100 pos_re ringone_con_banner_div">
            <div class="content dis_column ali_cen" style="margin-top:0;padding-top:3vw">
                <div class="w100 dis_column ali_cen">
                    <p class="con_title" style="color:#fff">企业彩铃对企业的作用</p>
                    <p class="con_title_des" style="color:#fff">丰富的应用场景 满足各行业的企业彩铃需求</p>
                </div>
                <div class="dis_row just_bet ali_cen ringone_cc_banner_div1">
                    <div class="ringone_con_banner_con1 dis_column ali_cen just_cen" v-for="(item,index) in partnerList1" :key="index">
                        <img :src=item.img class="ringone_con_banner_con_i1 w100">
                        <p class="ringone_con_banner_con_t1">{{item.title}}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="w100 pos_re">
            <div class="des_circle"></div>
            <div class="des_circle1"></div>
            <div class="des_circle2"></div>
            <div class="content" style="margin-top:7vw;width:55vw;margin-bottom:7vw">
                <div class="w100 dis_column ali_cen">
                    <p class="con_title">产品优势</p>
                    <p class="con_title_des">PRODUCT ASVANTAGE</p>
                    <div class="dis_row ali_cen just_cen">
                        <p class="con_title_line"></p>
                        <img src="../../static/img/index/con_title_img.png" class="con_title_img">
                        <p class="con_title_line"></p>
                    </div>
                    <div class="dis_row just_bet w100 margin_top_2 flex_wrap">
                        <div class="ringone_con_advantage dis_column ali_cen just_cen" v-for="(item,index) in advantageList" :key="index">
                            <img :src=item.img class="ringone_con_banner_con_i" style="width:4vw">
                            <p class="ringone_con_banner_con_t">{{item.title}}</p>
                            <p class="ringone_con_advantage_text">{{item.con}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {titleList} from '../assets/js/global.js'
export default {       
    name: 'ringone',
    data () {
        return {
            partnerList1:[{
                img:'../../static/img/1-1.png',
                title:'企业宣传'
            },{
                img:'../../static/img/zhufu.jpg',
                title:'节日祝福'
            },{
                img:'../../static/img/1-2.png',
                title:'产品推广'
            },{
                img:'../../static/img/zhanpian.jpg',
                title:'照片集锦'
            },{
                img:'../../static/img/zhaopin.jpg',
                title:'企业招聘'
            }],
            partnerList:[{
                img:'../../static/img/yidong.png',
                title:'中国移动',
                con:'从2008年接入中国移动企业彩铃运营，截止目前共发展企业彩铃500万线，累计收入超过5亿元人民币'
            },{
                img:'../../static/img/liantong.png',
                title:'中国联通',
                con:'从2008年接入中国移动企业彩铃运营，截止目前共发展企业彩铃500万线，累计收入超过5亿元人民币'
            },{
                img:'../../static/img/dianxin.png',
                title:'中国电信',
                con:'从2008年接入中国移动企业彩铃运营，截止目前共发展企业彩铃500万线，累计收入超过5亿元人民币'
            }],
            advantageList:[{
                img:'../../static/img/home.png',
                title:'三网合一',
                con:'三大运营商合一平台，操作方便快捷'
            },{
                img:'../../static/img/xietong.png',
                title:'利润最优',
                con:'全网利润最优，签订合同有保障'
            },{
                img:'../../static/img/kefu.png',
                title:'售后保障',
                con:'专业客服团队，1分钟之内响应代理消息'
            },{
                img:'../../static/img/kuaisu.png',
                title:'开通迅速',
                con:'录入资料后立即同步，绿色直通车，快速受理业务'
            },{
                img:'../../static/img/shouquan.png',
                title:'一手渠道',
                con:'三大运营商直接授权一级代理商'
            },{
                img:'../../static/img/duoji.png',
                title:'多级代理',
                con:'无限制发展子代理，独立平台'
            }]
        }
    },
    created(){
        document.documentElement.scrollTop = document.body.scrollTop = 0;
        this.$root.indexTabFlag = 0
        titleList(this.$root.indexTabList,1)
    },
    mounted () {
        window.addEventListener('scroll', this.scrollToTop)
    },
    destroyed () {
        window.removeEventListener('scroll', this.scrollToTop)
    },
    methods:{
        scrollToTop(){
            let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
            if(scrollTop > 100){
            this.$root.indexTabFlag = 1
            }else{
            this.$root.indexTabFlag = 0
            }
        }
    }
}
</script>

<style scoped>
    .banner_img{
        width: 100%;
        height: 25vw;
    }
    .banner{
        position: absolute;
        top: 3.4vw;
        left: 0;
        width: 100%;
        height: 21.6vw;
    }
    .banner_con{
        width: 40vw;
        height: 18vw;
        margin: 0 auto;
        color: #fff;
        font-size: 0.85vw;
    }
    .banner_title{
        font-size: 2.5vw;
        margin-bottom: 0.5vw;
    }
    .banner_des{
        font-size: 0.8vw;
    }
    .banner_con_text{
        font-size: 1vw;
        letter-spacing: 0.15vw;
        line-height: 1.4vw;
        margin-top: 2vw;
        width: 30vw;
    }
    .application_left,.application_right{
        width: 36vw;
    }
    .application_left_icon{
        width: 28vw;
        margin-bottom: 1vw;
    }
    .application_left_icon_num{
        position: absolute;
        top: 50%;
        left: 50%;
        margin-left: -0.75vw;
        margin-top: -0.75vw;
        font-size: 1.5vw;
        color: #fff;
    }
    .application_LL_icon{
        width: 21vw;
        font-size: 0.7vw;
        line-height: 1.3vw;
        color: #999;
        padding: 1vw;
        background-color: #efefef;
    }
    .application_LL_icon_title{
        font-size: 1vw;
        color: #333;
        margin-bottom: 1vw;
    }
    .ringone_con_banner_div{
        margin-top: 7vw;
        height: 31vw;
        background: url(../../static/img/ringone_con_banner.png) no-repeat;
        background-size: 100% 100%;
    }
    .ringone_cc_banner_div1{
        width:75vw ;
        margin-top: 3vw;
    }
    .ringone_con_banner_con1{
        width: 13.5vw;
        height: 16vw;
        border-radius: 0.9vw;
        background-color: #fff;
        font-size: 0.85vw;
        text-align: center;
        line-height: 1.7vw;
        transition: all .6s;
        overflow: hidden;
    }
    
    .ringone_cc_banner_div{
        width:55vw ;
        margin-top: 3vw;
    }
    .ringone_con_banner_con{
        width: 15vw;
        height: 18vw;
        border-radius: 0.9vw;
        background-color: #fff;
        font-size: 0.85vw;
        text-align: center;
        line-height: 1.7vw;
        transition: all .6s;
    }
    .ringone_con_banner_con p{
        width: 12vw;
    }
    .ringone_con_advantage_text{
        width: 10vw;
        height: 5vw;
    }
    .ringone_con_banner_con_t{
        font-size: 1vw;
        color: #333;
    }
    .ringone_con_banner_con_t1{
        font-size: 1vw;
        line-height: 3vw;
        color: #333;
    }
    .ringone_con_banner_con_i{
        margin:1vw 0;
        width: 3vw;
    }
    .ringone_con_banner_con_i1{
        height: 13.1vw;
    }
    .ringone_con_advantage{
        width: 16vw;
        height: 14vw;
        margin-top: 2vw;
        border-radius: 0.9vw;
        border:0.04vw solid #e3e0e0;
        color: #999;
        font-size: 0.85vw;
        text-align: center;
        line-height: 1.7vw;
        transition: all .6s;
    }
    .des_circle{
        position: absolute;
        top: 25vw;
        left: 8vw;
        transform: translate(-50%,-50%);
        opacity: .5;
        border-radius: 50%;
        width: 15vw;
        height: 15vw;
        border: 4px solid #d1eaf3;
        background-color:  #d1eaf3;
        animation:mymove1 25s infinite;
    }
    .des_circle2{
        position: absolute;
        top: 10vw;
        right: -10vw;
        animation:mymove3 25s infinite;
        transform: translate(-50%,-50%);
        opacity: .3;
        border-radius: 50%;
        width: 25vw;
        height: 25vw;
        border: 4px solid #d1eaf3;
        background-color:  #d1eaf3;
    }
    .des_circle1{
        position: absolute;
        top: 10vw;
        left: 0%;
        transform: translate(-50%,-50%);
        opacity: .5;
        border-radius: 50%;
        width: 5vw;
        height: 5vw;
        border: 4px solid #d1eaf3;
        background-color:  #d1eaf3;
        animation:mymove2 35s infinite;
    }
    @media screen and (min-width: 1100px) {
        .ringone_con_banner_con1:hover{
            transform: translateY(-15px);
        }
        .ringone_con_banner_con:hover,.ringone_con_advantage:hover{
            transform: translateY(-15px);
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Ringone.vue